export const imgUrl = {
    firstLogo : '../../../assets/img/videojet-logo.png',
    secondLogo: '../../../assets/img/Logo.png',
    tick: '../../../assets/img/tick.png',
    opcoName: 'Videojet Remote Service',
    adminEmail: 'admin@videojet.com',
    opcoPolicy: 'https://www.videojet.com/us/homepage/general/privacy-policy.html#'
};

